module.exports = __webpack_public_path__ + "img/header_icon_tw.5ac4e20b.svg";